import { LoggerHelper } from 'ff-shared-components-core';

class HostAppCommunicationBridge {
	private static get hasParentIframeWindow(): boolean {
		return 'parentIFrame' in window;
	}

	private static sendMessage(message: string): void {
		if (HostAppCommunicationBridge.hasParentIframeWindow) {
			window['parentIFrame'].sendMessage(message, '*');
		} else {
			LoggerHelper.log("HostAppCommunicationBridge ERROR. parentIFrame doesn't exists in window object");
		}
	}

	private static goToPage(action: string): void {
		HostAppCommunicationBridge.sendMessage(`gotopage:${action}`);
	}

	public static scrollToTop(): void {
		HostAppCommunicationBridge.sendMessage(`scrolltotop`);
	}

	public static goToHome(): void {
		HostAppCommunicationBridge.goToPage('home');
	}
}

export const HostAppCommunicationBridgeHelper = HostAppCommunicationBridge;
